<template>
  <div class="scrap-bd tb" v-if="funcView.service_record_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addEvent"
            v-if="funcView.offline_service_add"
          >{{funcView.offline_service_add}}</el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click.native="exportTable('deviceScrapExport', formSearch)"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            placeholder="Modem SN"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['action']"
      >
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="seeBtn(scope.row)" v-if="funcView.service_record_preview">{{funcView.service_record_preview}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>


        <!-- 查看 -->
    <offlineRecordDetailDialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList"
    >
    </offlineRecordDetailDialog>


  </div>
</template>

<script>
import apis from '@/utils/apis.js';
import offlineRecordDetailDialog from './children/offlineRecord_detail_dialog.vue';
// import deviceAcrapDialog from '@/pages/crm/components/deviceAcrapDialog.vue';
// import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
// import offlineServiceModemSnDialog from './children/offlineService_modemSn_dialog.vue';

export default {
  name: 'offlineService',
  components: {
    offlineRecordDetailDialog,
    // offlineServiceModemSnDialog,
    // deviceAcrapDialog,
    // approvalDialog
  },
  data() {
    return {
      provide: true,
      tableCode: 'offline_record',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1
      },
      totalRows: null,
      tableList: [],
      // 查看
      dialogVisible: false,
      dialogModel: {},


    };
  },
  methods: {
    getTableList() {
      this.$getJSON(apis.serviceModemRecordPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    seeBtn(row) {
      this.dialogModel.type = 'watch';
      this.dialogModel.title = this.$t('asm_offlineRecord.fu_wu_ji_lu');
      this.dialogModel.serviceRecordId = row.serviceRecordId;
      this.dialogVisible = true;
    },
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();
    this.getTableList();
  },
  activated() {
    this.getTableList();
  },

};
</script>

<style></style>
